export const container = ({ theme: { colors } }) => ({
    padding: '2.5rem 1.875rem 0',
});
